export const GCS_PUB_DATA_BASE = "https://storage.googleapis.com/adgepublic/pub_data";

export interface CreativeAssetUrls {
  thumbnailUrl: string;
  assetUrl: string;
}

/** First client partition when customerPartition is comma-separated (Retool parity). */
export function primaryClientPartition(customerPartition: string | null | undefined): string {
  if (!customerPartition) return "";
  return customerPartition.split(",")[0]?.trim() ?? "";
}

function assetExtension(objectType: string): "png" | "mp4" {
  return objectType.toLowerCase() === "image" ? "png" : "mp4";
}

/**
 * Canonical GCS URLs for creative thumbnails and assets.
 * Matches opportunities API and drilldown patterns (`adgepublic/pub_data`).
 */
export function buildCreativeAssetUrls(
  hash: string,
  objectType: string,
  customerPartition: string | null | undefined,
): CreativeAssetUrls {
  const client = primaryClientPartition(customerPartition);
  const ext = assetExtension(objectType);
  return {
    thumbnailUrl: `${GCS_PUB_DATA_BASE}/${client}/thumbnails/${hash}.png`,
    assetUrl: `${GCS_PUB_DATA_BASE}/${client}/assets/${hash}.${ext}`,
  };
}
